module.exports = __webpack_public_path__ + "static/media/nieruchomosci.a850bc1a.jpeg";